import config from '@/config.js';
import platform from '@/mixins/platform.js';

// TODO: データ取得できるようになったら消す
import stub from '@/stub.js';

export default {
  strict: true,
  namespaced: true,
  state: {
    fitOrientation: null,
    isShownVisualizationPanel: false,
    visualizationLayerType: 'default',
    visualizationPinTypes: ['spots'],
    svgElm: null,
    baseDomRect: {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
    },
    // TODO: transformでtranslateとscaleはくくれるかもしれない
    translate: { // NOTE: ドラッグ中のxy座標の値を同期
      x: 0,
      y: 0,
    },
    scale: 1,     // NOTE: HTMLのDomの拡大率
    // TODO: 数字が小さくなると広域、数字が大きくなると詳細
    zoomLevel: 1, // NOTE: 地図画像の縮尺の表現
    ruler: {
      min: 0,     // NOTE: ルーラーの論理的な長さの最小値
      max: 0,     // NOTE: ルーラーの論理的な長さの最大値
      width: 0,   // NOTE: ルーラーの表示上の線の長さ
      text: '0m', // NOTE: ラベルのフォーマット
      maxPx: 70,  // NOTE: 固定値
      minPx: 28,  // NOTE: 固定値(しきい値に2~5があるのでmax * 0.4にする)
    },
    area: {},
    spots: [],
    items: [],
    persons: [],
    currentFloorLevel: 0,
    shiftMap: false,
  },
  getters: {
    mapSize(state) {
      let level = 1;

      if (state.scale < 2) {
        level = 1;
      } else if (state.scale > 3) {
        level = 3;
      } else {
        level = Math.floor(state.scale);
      };

      return level;
    },
    includesSpotsPin: (state) => state.visualizationPinTypes.includes('spots'),
    includesItemsPin: (state) => state.visualizationPinTypes.includes('items'),
    includesPersonsPin: (state) => state.visualizationPinTypes.includes('persons'),
  },
  mutations: {
    transformTranslate(state, value) {
      state.translate = value;
    },
    transformScale(state, value) {
      state.scale = value;
    },
    getSvgElm(state, elm) {
      state.svgElm = elm;
    },
    getSpots(state, spots) {
      state.spots = spots;
    },
    getItems(state, items) {
      state.items = items;
    },
    getPersons(state, persons) {
      state.persons = persons;
    },
    setCurrentFloorLevelIndex(state, value) {
      state.currentFloorLevel = value;
    },
    toggleVisualizationPanel(state, value) {
      state.isShownVisualizationPanel = value;
    },
    switchVisualizationPinType(state, value) {
      const allowedVisualizationPinTypes = ['spots', 'items', 'persons'];
      if (!allowedVisualizationPinTypes.includes(value)) return console.error(`${value} is not allowed to visualizationPinType`);

      if (state.visualizationPinTypes.includes(value)) {
        state.visualizationPinTypes = state.visualizationPinTypes.filter((pinType) => pinType !== value);
      } else {
        state.visualizationPinTypes.push(value);
      }

    },
    resetVisualizationPinType(state, value) {
      state.visualizationPinTypes = ['spots'];
    },
    setVisualizationLayerType(state, value) {
      const allowedVisualizationLayerTypes = config.visualizationLayers.map((layer) => layer.value);

      if (!allowedVisualizationLayerTypes.includes(value)) return console.error(`${value} is not allowed to visualizationLayerType`);

      state.visualizationLayerType = value;
    },
    clearShiftMap(state) {
      state.shiftMap = false;
    },
  },
  actions: {
    getFitOrientation({ state, rootState, rootGetters }) {
      // NOTE: 縦横どちらにフィットしているかの判定
      const currentBuildingId = rootState.current.buildingId;
      const currentBuilding = rootGetters['area/buildingFind'](currentBuildingId);
      const containerRatio = window.innerHeight / window.innerWidth;
      const roomRatio = currentBuilding.depth / currentBuilding.width;
      let fit;

      if (containerRatio < 1) {
        // NOTE: 横長画面
        if (containerRatio < roomRatio) {
          fit = 'height';
        } else {
          fit = 'width';
        };
      } else {
        // NOTE: 縦長画面
        if (containerRatio < roomRatio) {
          fit = 'height';
        } else {
          fit = 'width';
        };
      };

      state.fitOrientation = fit;
    },
    saveBaseDomRect({ state, rootState, rootGetters }) {
      let height, width, x, y;
      const currentBuildingId = rootState.current.buildingId;
      const currentBuilding = rootGetters['area/buildingFind'](currentBuildingId);
      // NOTE: サイネージは全画面で見るため幅固定
      const windowWidth = 1920;
      const windowHeight = 1080;

      if (state.fitOrientation == 'height') {
        height = windowHeight;
        width = currentBuilding.width / currentBuilding.depth * height;
        y = 0;
        x = (window.innerWidth - width) / 2;
      } else {
        width = windowWidth;
        height = currentBuilding.depth / currentBuilding.width * width;
        x = 0;
        y = (windowHeight - height) / 2;
      };
      state.baseDomRect = {
        width: width,
        height: height,
        x: x,
        y: y,
      };
    },
    switchArea({dispatch, commit, state}, id) {
      // TODO: サーバーから取得する
      const area = stub[`area_${id}`];

      // NOTE: エリア切替時には一番下のフロアが表示されるように昇順に並べ替え
      area.floors.sort((a,b) => {
        if (a.level < b.level) return -1;
        if (a.level > b.level) return 1;
        return 0;
      });

      state.area = area;

      state.currentFloorLevel = 0;
      state.width = area.width;
      state.height = area.height;
      state.image_1 = area.floors[state.currentFloorLevel].image_1;
      state.image_2 = area.floors[state.currentFloorLevel].image_2;
      state.image_3 = area.floors[state.currentFloorLevel].image_3;

      // TODO:ランダム生成しているのでサーバーから取得する
      // NOTE: 場所を取得
      const spots = stub[`spots`](area);
      commit('getSpots', spots);

      // NOTE: モノを取得
      const items = stub[`items`](area);
      commit('getItems', items);

      // NOTE: 人を取得
      const persons = stub[`persons`](area);
      commit('getPersons', persons);

      // NOTE: 地図のDOM情報を更新
      commit('getFitOrientation')
      commit('saveBaseDomRect');

    },
    switchShiftMap({ state, commit, rootState, rootGetters }, x) {
      const currentBuilding = rootGetters['area/buildingFind'](rootState.current.buildingId);
      // NOTE: 詳細がピンにかぶってしまうときに地図をずらすフラグ
      state.shiftMap = window.innerWidth / currentBuilding.width * x < 620;
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/data/map.js